//libs\core\shell\src\lib\system\system-config.interface.ts
export type ShellThemeMode = 'dark' | 'light';

export interface ShellSystemConfig {
  themeMode: ShellThemeMode;
  menuEditingEnabled: boolean;
  updatedAt: string | null;
}

export const DEFAULT_SHELL_SYSTEM_CONFIG: ShellSystemConfig = {
  themeMode: 'dark',
  menuEditingEnabled: true,
  updatedAt: null,
};
